import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import type { NotificationFeedPage } from '@/types/notification-feed';

export type NotificationFeedState = NotificationFeedPage & {
  loaded: boolean;
};

export const notificationFeedInitialState: NotificationFeedState = {
  items: [],
  pageNumber: 0,
  pageSize: 20,
  totalCount: 0,
  totalPages: 0,
  hasPrevious: false,
  hasNext: false,
  loaded: false,
};

const slice = createSlice({
  name: 'notificationFeed',
  initialState: notificationFeedInitialState,
  reducers: {
    resetNotificationFeedAction: () => notificationFeedInitialState,
    setNotificationFeedAction(
      state,
      { payload }: PayloadAction<{ page: NotificationFeedPage; append: boolean }>,
    ) {
      const nextItems = payload.append ? [...state.items, ...payload.page.items] : payload.page.items;
      const seen = new Set<string>();
      state.items = nextItems.filter((item) => {
        if (seen.has(item.notificationId)) return false;
        seen.add(item.notificationId);
        return true;
      });
      state.pageNumber = payload.page.pageNumber;
      state.pageSize = payload.page.pageSize;
      state.totalCount = payload.page.totalCount;
      state.totalPages = payload.page.totalPages;
      state.hasPrevious = payload.page.hasPrevious;
      state.hasNext = payload.page.hasNext;
      state.loaded = true;
    },
    markNotificationReadAction(state, { payload }: PayloadAction<string>) {
      const item = state.items.find((notification) => notification.notificationId === payload);
      if (item) {
        item.isRead = true;
        item.readAt = new Date().toISOString();
      }
    },
  },
});

export const {
  resetNotificationFeedAction,
  setNotificationFeedAction,
  markNotificationReadAction,
} = slice.actions;

export default slice.reducer;
